import { TextWithTooltip } from "@/components/text-with-tooltip"
import { uuidv4 } from "@/lib/generate-uuidv4"
import { useAppendChatHistoryMessage, useReadChatHistory } from "@/modules/chats/hooks/useChatHistory"
import { useChatInputContext, useChatInputStateGetter } from "@/modules/chats/stores/useChatInputStore"
import { AiTrackingMetadata } from "@/modules/chats/types/chat-message"

export const NextBestQuestionChip = () => {
  const nextBestQuestions = useChatInputContext((store) => store.nextBestQuestions)
  const getChatInputState = useChatInputStateGetter()
  const appendHistory = useAppendChatHistoryMessage()
  const readChatHistory = useReadChatHistory()

  const handleChooseBestQuestion = (selectedQuestion: string) => {
    const { nextBestQuestions, setNextBestQuestions, setAiTrackingMetadata } = getChatInputState()

    const currentText = readChatHistory().at(-1)?.content ?? ""
    const newMessageText = currentText ? `${currentText}\n\n${selectedQuestion}` : selectedQuestion

    setNextBestQuestions(nextBestQuestions.filter((question) => question !== selectedQuestion))
    appendHistory(newMessageText, "NEXT_BEST_QUESTION")

    const trackingMetadata: AiTrackingMetadata = {
      id: uuidv4(),
      name: "Next best questions",
      previousText: currentText,
      newText: newMessageText,
      selectedItem: selectedQuestion,
      aiFeature: "NEXT_BEST_QUESTION",
      createdAt: new Date().toISOString(),
    }
    setAiTrackingMetadata([trackingMetadata])
  }

  return (
    <div className="flex shrink-0 flex-wrap justify-start gap-2">
      {nextBestQuestions?.length > 0 &&
        nextBestQuestions.map((question) => (
          <button
            key={question}
            className="grid-cols-1fr-auto border-on-plum-surface bg-plum-surface-subdued text-on-plum-surface hover:bg-plum-surface grid max-h-8 cursor-pointer rounded-md border p-1.5 text-sm"
            onClick={(evt) => {
              evt.preventDefault()
              evt.stopPropagation()
              handleChooseBestQuestion(question)
            }}>
            <TextWithTooltip>{question}</TextWithTooltip>
          </button>
        ))}
    </div>
  )
}
